import { render, staticRenderFns } from "./CommissionItem.vue?vue&type=template&id=4fc26146&scoped=true"
import script from "./CommissionItem.vue?vue&type=script&lang=js"
export * from "./CommissionItem.vue?vue&type=script&lang=js"
import style0 from "./CommissionItem.vue?vue&type=style&index=0&id=4fc26146&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4fc26146",
  null
  
)

export default component.exports